import { CheckboxInput } from 'journey-ui'
import React, { useCallback, useContext } from 'react'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { TileModalToppingContext } from '../../contexts/TileModalToppingContext'
import { useToppingPriceLabel } from '../../hooks/useToppingPriceLabel'
import { getTileRules, isRuleMaxed } from './TileCard'
import { useToppingPriceUpdater } from '../../hooks/useToppingPriceUpdater'

interface Props {
  tileToppings: ItemTopping[]
  tile: Tile
  toppingName: string
}

export const TileModalToppingBtn: React.FC<Props> = ({ tileToppings, toppingName, tile }) => {
  const { form, setForm, rules, hasFreeAvailable } = useContext(ItemPageContext)
  const portionedToppings: Record<string, ItemTopping> = {}

  tileToppings.filter((topping) => topping.size_name === form.size_name && topping.name === toppingName).forEach((t) => {
    portionedToppings[t.portion_name] = t
  })

  const selectedTopping: ItemTopping | undefined = form.toppings.find((t) => t.name === toppingName && t.tile_hash_id === tile.hash_id)
  const tileTopping = tileToppings.find((t) => t.name === toppingName && t.tile_hash_id === tile.hash_id)
  const isChecked = !!selectedTopping
  const updateToppingPrices = useToppingPriceUpdater()

  const onClickHandle = useCallback(() => {
    setForm((form) => {
      const existingTopping = form.toppings.some((t) => t.name === toppingName && t.tile_hash_id === tile.hash_id)
      const isRemoving = !!existingTopping // already have this topping and we clicked? remove it.

      const newTopping = {
        ...tileTopping,
        free_quantity: hasFreeAvailable(tileTopping) ? 1 : 0,
        section_topping_price: tileTopping.price,
        tile_hash_id: tile.hash_id,
        quantity: 1,
      }

      newTopping.price = updateToppingPrices([newTopping])[0].price

      const toppingPriceChange = (newTopping.price * form.quantity)
      const newPrice = isRemoving ? form.price - toppingPriceChange : form.price + toppingPriceChange

      return {
        ...form,
        price: newPrice,
        toppings: isRemoving ? form.toppings.filter((t) => t.name !== toppingName) : [...form.toppings, newTopping],
      }
    })
  }, [setForm, tileTopping, hasFreeAvailable, tile.hash_id, updateToppingPrices, toppingName])

  const isDisabled = !!getTileRules(rules, tile).some((r) => isRuleMaxed(r, form))

  return (
    <TileModalToppingContext.Provider value={{ tileToppings, tile, selectedTopping, toppingName }}>
      <div className="flex items-center w-full space-x-4 border-dashed border-b">
        <CheckboxInput
          disabled={isDisabled && !isChecked}
          onClick={onClickHandle}
          checked={isChecked}
          label={(
            <div className="flex items-center justify-between">
              <span>{toppingName}</span>
              <span>{useToppingPriceLabel(selectedTopping ?? tileTopping)}</span>
            </div>
          )}
          className="w-auto flex-grow topping-btn"
        />
      </div>
    </TileModalToppingContext.Provider>
  )
}
